import { gql } from '@apollo/client';

export const ALL_AUCTION_TEMPLATES_QUERY_NAME = 'AllAuctionTemplates';
export const ALL_AUCTION_TEMPLATES = gql`
    query ${ALL_AUCTION_TEMPLATES_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allAuctionTemplates(
            page: $page,
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            availableProducts {
                productId
                name
                productType
                quantityUnit
            }
            availableZones {
                code
                name
                currency {
                    code
                }
            }
            availableAuctioneers {
                name
                memberId
                technicalAuctioneer
                regularAuctioneer
                euAuctioneer
            }
            availableAuctionTypes
            availableBiddingTypes
            availableTradePriceCalculationTypes
            availableAuctionAlgorithms
            availableAuctionAcceptanceTypes
            availableSettlStartTypes
            defaultAuctionDurationHours
            auctionTemplateList {
                totalCount
                models {
                    id
                    name
                    product {
                        name
                        productId
                        productType
                    }
                    description
                    openingTime
                    closureTime
                    algorithm
                    showLastPrice
                    showRanking
                    limitBidModification
                    minPrice
                    maxPrice
                    spotReferencePrice
                    absoluteDeviation
                    relativeDeviation
                    zone {
                        code
                        name
                    }
                    auctioneerMember {
                        name
                        memberId
                    }
                    auctionType
                    biddingType
                    auctionAcceptanceType
                    tradePriceCalculationType
                    quantity
                    deliveryYear
                    power
                    smallestUnit
                    settlStartType
                    maxBidSize
                    revenueSplit        
                }
            }
        }
    }
`;

export const CREATE_AUCTION_TEMPLATE = gql`
    mutation CreateAuctionTemplate(
        $name: String!, 
        $deliveryYear: Int, 
        $productId: String,
        $zoneCode: String,
        $auctioneerMemberId: String,
        $quantity: Int,
        $power: Int,
        $openingTime: LocalTime,
        $closureTime: LocalTime,
        $auctionType: AuctionType,
        $biddingType: BiddingType,
        $tradePriceCalculationType: TradePriceCalculationType,
        $auctionAcceptanceType: AuctionAcceptanceType,
        $auctionAlgorithm: AuctionAlgorithm,
        $showLastPrice: Boolean,
        $showRanking: Boolean,
        $limitBidModification: Boolean,
        $smallestUnit: Int,
        $minPrice: Price,
        $maxPrice: Price,
        $spotReferencePrice: Price,
        $absoluteDeviation: Price,
        $relativeDeviation: BigDecimal,
        $description: String,
        $settlStartType: SettlStartType,
        $maxBidSize: Int,
        $revenueSplit: Int,
        $correlationId: String!
    ) {
        createAuctionTemplate(
            name: $name,
            deliveryYear: $deliveryYear,
            productId: $productId,
            zoneCode: $zoneCode,
            auctioneerMemberId: $auctioneerMemberId,
            quantity: $quantity,
            power: $power,
            openingTime: $openingTime,
            closureTime: $closureTime,
            auctionType: $auctionType,
            biddingType: $biddingType,
            tradePriceCalculationType: $tradePriceCalculationType,
            auctionAcceptanceType: $auctionAcceptanceType,
            auctionAlgorithm: $auctionAlgorithm,
            showLastPrice: $showLastPrice,
            showRanking: $showRanking,
            limitBidModification: $limitBidModification,
            smallestUnit: $smallestUnit,
            minPrice: $minPrice,
            maxPrice: $maxPrice,
            spotReferencePrice: $spotReferencePrice
            absoluteDeviation: $absoluteDeviation
            relativeDeviation: $relativeDeviation
            description: $description,
            settlStartType: $settlStartType,
            maxBidSize: $maxBidSize,
            revenueSplit: $revenueSplit,
            correlationId: $correlationId
        ) {
            name
        }
    }
`;

export const UPDATE_AUCTION_TEMPLATE = gql`
    mutation UpdateAuctionTemplate(
        $id: Int!,
        $name: String!, 
        $deliveryYear: Int, 
        $productId: String,
        $zoneCode: String,
        $auctioneerMemberId: String,
        $quantity: Int,
        $power: Int,
        $openingTime: LocalTime,
        $closureTime: LocalTime,
        $auctionType: AuctionType,
        $biddingType: BiddingType,
        $tradePriceCalculationType: TradePriceCalculationType,
        $auctionAcceptanceType: AuctionAcceptanceType,
        $auctionAlgorithm: AuctionAlgorithm,
        $showLastPrice: Boolean,
        $showRanking: Boolean,
        $limitBidModification: Boolean,
        $smallestUnit: Int,
        $minPrice: Price,
        $maxPrice: Price,
        $spotReferencePrice: Price,
        $absoluteDeviation: Price,
        $relativeDeviation: BigDecimal,
        $description: String,
        $settlStartType: SettlStartType,
        $maxBidSize: Int,
        $revenueSplit: Int,
        $correlationId: String!
    ) {
        updateAuctionTemplate(
            id: $id,
            name: $name,
            deliveryYear: $deliveryYear,
            productId: $productId,
            zoneCode: $zoneCode,
            auctioneerMemberId: $auctioneerMemberId,
            quantity: $quantity,
            power: $power,
            openingTime: $openingTime,
            closureTime: $closureTime,
            auctionType: $auctionType,
            biddingType: $biddingType,
            tradePriceCalculationType: $tradePriceCalculationType,
            auctionAcceptanceType: $auctionAcceptanceType,
            auctionAlgorithm: $auctionAlgorithm,
            showLastPrice: $showLastPrice,
            showRanking: $showRanking,
            limitBidModification: $limitBidModification,
            smallestUnit: $smallestUnit,
            minPrice: $minPrice,
            maxPrice: $maxPrice,
            spotReferencePrice: $spotReferencePrice
            absoluteDeviation: $absoluteDeviation
            relativeDeviation: $relativeDeviation
            description: $description,
            settlStartType: $settlStartType,
            maxBidSize: $maxBidSize,
            revenueSplit: $revenueSplit,
            correlationId: $correlationId
        ) {
            name
        }
    }
`;

export const ON_AUCTION_TEMPLATE_CHANGED = gql`
    subscription onAuctionTemplateChanged {
        auctionTemplateChanged {
            correlationId
            action
            model {
                id
                name
            }
        }
    }
`;

export const DELETE_AUCTION_TEMPLATE = gql`
    mutation DeleteAuctionTemplate(
        $id: Int!,
        $correlationId: String!
    ) {
        deleteAuctionTemplate(
            id: $id, 
            correlationId: $correlationId
        ) {
            id
            name
        }
    }
`;
